export default __webpack_public_path__ + "static/char-s-34-zh-Hant-6d19cfca70d4b8a7c6e8d9e766ee61bb.webp";